import { Loader, Overlay, Stack, Text, Title } from '@mantine/core';

import { useBackendMaintenance } from '../hooks/useBackendMaintenance';

/**
 * Full-screen curtain shown while the backend is confirmed unreachable
 * (Cloud SQL maintenance, backend restart). Renders nothing in the healthy
 * state, which is why it mounts unconditionally next to the router. It
 * deliberately blocks interaction rather than letting clicks fire requests
 * that can only fail; recovery hides it and refetches automatically, so the
 * copy tells the user not to refresh.
 */
export function MaintenanceOverlay() {
  const isDown = useBackendMaintenance();

  if (!isDown) {
    return null;
  }

  return (
    <Overlay fixed center backgroundOpacity={0.55} blur={4} zIndex={10_000}>
      <Stack align="center" gap="sm" p="xl" maw={440} ta="center">
        <Loader />
        <Title order={3} c="white">
          Brief maintenance in progress
        </Title>
        <Text c="white">
          We are reconnecting to our servers. This usually takes under a minute, and the page will
          resume by itself — no need to refresh.
        </Text>
      </Stack>
    </Overlay>
  );
}
